import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MetaHttpAdapter } from '../../http-adapters/meta-http-adapter';
import { HttpReportsService } from '@sp-core/http-services/http-reports/http-reports.service';
import { ReportsHttpAdapter } from '@sp-core/http-adapters/reports-http-adapter';

@Injectable({
  providedIn: 'root',
})
export class LabsReportService {
  constructor(
    public readonly _httpReportsService: HttpReportsService,
    public readonly _reportsHttpAdapter: ReportsHttpAdapter,
  ) {}

  public getTableData(params: HttpParamsOptions): Observable<ITableData<ILabsReport>> {
    return this._httpReportsService.getLabsReports(params).pipe(
      map((data) => ({
        data: data.data.map((item) => this._reportsHttpAdapter.transformToLabsReport(item)),
        meta: MetaHttpAdapter.transformToMeta(data.meta),
      })),
    );
  }

  /**
   * Starts an export. The response is only a process id — the file itself is built asynchronously
   * and reaches the user through an emailed link, which brings them back to the app with
   * `?labs_report=<processId>` and is handled by AppComponent.
   */
  public exportTable(exportFormat: string, filters: HttpParamsOptions): Observable<IExportProcessId> {
    return this._httpReportsService
      .getLabsExportProcessId(exportFormat, filters)
      .pipe(map((res: IExportProcessIdApi) => this._reportsHttpAdapter.transformToProcessId(res)));
  }

  public getExportedTable(processId: string): Observable<Blob> {
    return this._httpReportsService.getLabsBlob(processId);
  }
}
